import C from '@elem/compPage/DeltaProUltra/Launch/Detail/components/C';
import css from './index.module.scss';
import { useGlobal } from '@/utils/useGlobal';
import { createEFPic } from '@/utils/useEFPic';
import EFShoppingCart from '@/components/UI/svg/LandingPage/EFShoppingCart';

const { EFPic } = createEFPic('/img/landingPage/pc/');

export default function B1() {
    const { useLang, useRouter } = useGlobal();
    const { t } = useLang('landingPage');
    const { locale } = useRouter();

    const SHOW_CART_SITE = ['sa', 'za', 'au'].includes(locale);
    const IS_NA_SITES = ['us', 'ca'].includes(locale);

    return (
        <div className={`landing_page_C ${css.landing_page_C}`}>
            {!IS_NA_SITES && (
                <div className="listRow">
                    <div className="listBox">
                        <div className="listItem listItem_1">
                            {SHOW_CART_SITE && <EFPic name={['expandable2.png', 'expandable2.png']} alt={t('secD_item_1')} />}
                            {!SHOW_CART_SITE && <EFPic name={['d-1.webp', 'd-1.png']} alt={t('secD_item_1')} />}
                            <div className="listItem_1_text">{t('secD_item_1')}</div>
                        </div>
                        <div className="listItem listItem_2">
                            <div className="listItem_2_top">
                                <EFPic name={['d-2.webp', 'd-2.png']} alt={t('secD_item_1')} />
                                <div className="listItem_2_top_text">
                                    <p>{t('secD_item_2_1')}</p>
                                    <p>{t('secD_item_2_2')}</p>
                                </div>
                            </div>
                            <div className="listItem_2_bottom">
                                <EFPic className="listItem_2_bottom_img" name={['d-3.webp', 'd-3.png']} alt={t('secD_item_2_3')} />
                                <div className="listItem_2_bottom_text">{t('secD_item_2_3')}</div>
                            </div>
                        </div>
                        <div className="listItem listItem_3">
                            <div className={`listItem_3_top ${SHOW_CART_SITE ? 'cart' : ''}`}>
                                {!SHOW_CART_SITE && (
                                    <>
                                        <EFPic name={['d-4.webp', 'd-4.png']} alt={t('secD_item_3_1')} />
                                        <div className="listItem_3_top_text">{t('secD_item_3_1')}</div>
                                    </>
                                )}
                                {SHOW_CART_SITE && (
                                    <>
                                        <EFShoppingCart />
                                        <div className="cart-text">{t('secD_item_3_cart')}</div>
                                    </>
                                )}
                            </div>
                            <div className="listItem_3_bottom">
                                <EFPic name={['d-5.webp', 'd-5.png']} alt={t('secD_item_3_2')} />
                                <div className="listItem_3_bottom_text">
                                    <p>{t('secD_item_3_2').substr(0, 7)}</p>
                                    <p>{t('secD_item_3_2').substr(7)}</p>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            )}
            {IS_NA_SITES && <C langKey="landingPage" />}
            {locale === 'au' && <p className="memo">{t('secD_memo')}</p>}
        </div>
    );
}
